<div mat-dialog-title>
  <mode-dialog-header>
    <h1 heading data-test="pdf-export-header-text">Export PDF</h1>
  </mode-dialog-header>
  <div class="status-content" mat-dialog-content>
    <div class="doc-icon">
      <capra-icon icon="illo-pdf-report" class="illo-pdf-report"></capra-icon>
      <div class="status-icon">
        <span class="status-icons">
          <capra-icon
            icon="illo-generating-export-success"
            *ngIf="success$ | async"
            data-test="pdf-export-illo-success"
          ></capra-icon>
          <capra-icon
            icon="illo-generating-export"
            *ngIf="loading$ | async"
            class="spin"
            data-test="pdf-export-illo-loading"
          ></capra-icon>
          <capra-icon
            icon="illo-generating-export-fail"
            *ngIf="error$ | async"
            data-test="pdf-export-illo-failure"
          ></capra-icon>
        </span>
      </div>
    </div>
  </div>
  <div class="status-text" mat-dialog-content data-test="pdf-export-status-text">
    {{ statusText$ | async }}
  </div>
  <div mat-dialog-actions class="menu-buttons">
    <capra-button
      data-test="pdf-export-cancel"
      *ngIf="(error$ | async) || showCancel"
      class="cancel-button"
      text="Cancel"
      variant="secondary"
      color="neutral"
      (clicked)="dismiss()"
    ></capra-button>
    <capra-button
      data-test="pdf-export-download"
      *ngIf="(error$ | async) === null"
      text="Download"
      class="download-button"
      [disabled]="(downloadLink$ | async) === null"
      (click)="downloadPDF()"
    ></capra-button>
  </div>
</div>
